// Please: Alphabetize the exports
export const CAF_EMAIL_AGENT_FEATURE = 'caf_email_agent_feature'
export const CAF_EMAIL_DISPLAY_MUTUAL_AVAILABILITY = 'caf_email_display_mutual_availability'
export const CAF_SIDE_THREADS = 'caf_side_threads'
export const ENT_IT_ACCOUNT_DELETION_EMAIL_VERIFICATION = 'ent_it_account_deletion_email_verification'
export const ENT_IT_COMMUNICATION_ARCHIVING_FEATURE = 'ent_it_communication_archiving_feature'
export const ENT_IT_RESCHEDULED_WORKFLOW_TRIGGER = 'ent_it_event_rescheduled_workflow_trigger'
export const ENT_IT_WORKFLOW_ACTION_EMAIL_SOMEONE_ELSE = 'ent_it_workflow_action_email_someone_else'
export const INTEGRATIONS_HUBSPOT_NEW_FIELDS_BUNDLED = 'integrations_hubspot_new_fields_bundled'
